"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const SnowplowProvider_1 = require("../SnowplowProvider");
const snowplow_js_common_1 = require("@angi/snowplow-js-common");
/**
 * Used to set enableEvent and dependencies to default values if none are passed in
 */
const defaultParams = {
    enableEvent: true,
    dependencies: [],
};
/**
 * React app self-describing event. Uses a React useEffect hook with passed in dependencies to
 * manage the number of self-describing events sent.
 *
 * @param params - object of possible values to pass to this method. Event is required
 */
const useEnhancedSelfDescribingEvent = (params) => {
    const { event, enableEvent, dependencies } = Object.assign(Object.assign({}, defaultParams), params);
    const isSnowplowReady = (0, SnowplowProvider_1.useIsSnowplowReady)();
    (0, react_1.useEffect)(() => {
        if (enableEvent && isSnowplowReady) {
            (0, snowplow_js_common_1.enhancedSelfDescribingEvent)(event);
        }
    }, [...dependencies, isSnowplowReady]);
};
exports.default = useEnhancedSelfDescribingEvent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlRW5oYW5jZWRTZWxmRGVzY3JpYmluZ0V2ZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3JlYWN0L2hvb2tzL3VzZUVuaGFuY2VkU2VsZkRlc2NyaWJpbmdFdmVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLGlDQUFrQztBQUNsQywwREFBeUQ7QUFFekQsaUVBQXVFO0FBRXZFOztHQUVHO0FBQ0gsTUFBTSxhQUFhLEdBQUc7SUFDbEIsV0FBVyxFQUFFLElBQUk7SUFDakIsWUFBWSxFQUFFLEVBQUU7Q0FDbkIsQ0FBQztBQUVGOzs7OztHQUtHO0FBQ0gsTUFBTSw4QkFBOEIsR0FBRyxDQUFDLE1BQTRDLEVBQVEsRUFBRTtJQUMxRixNQUFNLEVBQUUsS0FBSyxFQUFFLFdBQVcsRUFBRSxZQUFZLEVBQUUsbUNBQ25DLGFBQWEsR0FDYixNQUFNLENBQ1osQ0FBQztJQUVGLE1BQU0sZUFBZSxHQUFHLElBQUEscUNBQWtCLEdBQUUsQ0FBQztJQUU3QyxJQUFBLGlCQUFTLEVBQUMsR0FBRyxFQUFFO1FBQ1gsSUFBSSxXQUFXLElBQUksZUFBZSxFQUFFO1lBQ2hDLElBQUEsZ0RBQTJCLEVBQUMsS0FBSyxDQUFDLENBQUM7U0FDdEM7SUFDTCxDQUFDLEVBQUUsQ0FBQyxHQUFHLFlBQVksRUFBRSxlQUFlLENBQUMsQ0FBQyxDQUFDO0FBQzNDLENBQUMsQ0FBQztBQUVGLGtCQUFlLDhCQUE4QixDQUFDIn0=


// WEBPACK FOOTER //
// ../../../../src/react/hooks/useEnhancedSelfDescribingEvent.ts